import FilterBase from "./filter-base";
import FilterBox from "./filter-box";
import { FilterActiveValue } from "./active-filters";
import HttpClient from "../http-client";
import $ from "jquery";
// Only the autocomplete widget — the full jquery-ui-pack was 517KB (~30% of the bundle) for two widgets.
import 'jquery-ui/ui/widgets/autocomplete';

export default class TextFilter extends FilterBase {

    inputElement: Element;
    selectedItemsElement: Element;
    whisperedItemsElement: Element;

    constructor(baseElement: HTMLElement, filterBox: FilterBox) {
        super(baseElement, filterBox);
    }

    public init(){
        this.inputElement = this.baseElement.querySelector('[data-component-part="FilterInput"]');
        this.selectedItemsElement = this.baseElement.querySelector('[data-component-part="SelectedItemsList"]');
        this.initAutocomplete();
    }

    private initAutocomplete(){
        const jQueryElement = $(this.inputElement) as any;
        const selectedItemsElement = this.selectedItemsElement;
        const filterParamId = this.paramId;

        const delay = Number.parseInt(this.inputElement.getAttribute('data-search-delay'));
        const minLength = Number.parseInt(this.inputElement.getAttribute('data-search-min-chars'));

        jQueryElement.autocomplete({
            delay,
            minLength,
            source(request: any, response: any) {
                $.ajax({
                    url: `/filters/whisper/${filterParamId}`,
                    type: 'POST',
                    dataType: 'json',
                    data: { filterValue: request.term },
                    success(data) {
                        const parsedValues: any[] = JSON.parse(data);

                        let whisperedValues = parsedValues.map(entry => {
                            return {
                                label: entry.Name,
                                value: entry.Name,
                                id: entry.ListId
                            };
                        });

                        // get <li> elements from the list in array
                        const selectedItemNodes = [...selectedItemsElement.querySelectorAll('li')];

                        var selectedValueIds = selectedItemNodes.map(e => {
                            return parseInt($(e).attr('data-list-id'));
                        });

                        if (selectedValueIds.length > 0) {
                            whisperedValues = whisperedValues.filter(value => !selectedValueIds.some(id => id === value.id));
                        }

                        response(whisperedValues);
                    }
                });
            },
            select: (_, ui) => this.onValueSelected(ui.item),
        });
    }

    protected clearValuesInternal(){
        const selectedItemElements = this.selectedItemsElement.querySelectorAll('li');
        selectedItemElements.forEach(el => this.selectedItemsElement.removeChild(el));
    }

    public unselect(value: string): void {
        this.removeFromSelectedValues(Number(value));
    }

    private onValueSelected(item: any){
        this.addToSelectedValues(item);
        $(this.inputElement).val('');
        return false;
    }

    private addToSelectedValues(value: any) {
        this.selectedItemsElement.append(this.createSelectedValueElement(value));
        this.updateAttributeAndApplyChanges();
    }

    private createSelectedValueElement(item: any) : Element{
        const liElement = document.createElement('li');
        liElement.setAttribute('class', 'filters-summary__item');
        liElement.setAttribute('data-list-id', item.id);

        const aElement = document.createElement('a');
        aElement.setAttribute('href', '#');
        aElement.setAttribute('class', 'filters-summary__item-label');
        aElement.innerHTML = item.value;

        aElement.onclick = (event) =>{
            event.preventDefault();
            this.removeFromSelectedValues(item.id);
        }

        liElement.appendChild(aElement);

        return liElement;
    }

    private getSelectedValues(): string[]{
        return this.getSelectedValueElements()
            .map(e => e.dataset.listId);
    }

    private getSelectedValueElements(): HTMLLIElement[] {
        return [...this.selectedItemsElement.querySelectorAll('li')]
            .map(e => e as HTMLLIElement);
    }

    protected getSelectedValuesConcat(): string {
        return this.getSelectedValues().join(',');
    }

    protected getActiveFilterValues(): FilterActiveValue[]{
        const elements = this.getSelectedValueElements();
        return elements.map(e => <FilterActiveValue> { value: e.dataset.listId, displayName: e.textContent });
    }

    private removeFromSelectedValues(id: number) {
        var elementToDelete = this.selectedItemsElement.querySelector(`[data-list-id="${id}"]`);
        this.selectedItemsElement.removeChild(elementToDelete);
        this.updateAttributeAndApplyChanges()
    }

    protected async setValuesInternal(values: string): Promise<void> {    
    
        const urlEndpoint = `/filters/getlistitems/${this.paramId}/${values}`;

        const response = await new HttpClient().fetch(urlEndpoint);
        const items: any[] = JSON.parse(await response.json());

        items.forEach(valueToSelect => {
            this.addToSelectedValues({ id: valueToSelect.ListId, value: valueToSelect.Name });
        });
    }

}
